import { render, staticRenderFns } from "./InformativeListItem.vue?vue&type=template&id=2a069eae&scoped=true&"
import script from "./InformativeListItem.vue?vue&type=script&lang=js&"
export * from "./InformativeListItem.vue?vue&type=script&lang=js&"
import style0 from "./InformativeListItem.vue?vue&type=style&index=0&id=2a069eae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a069eae",
  null
  
)

export default component.exports